import React from 'react';

interface PriceFieldProps {
  id: string;
  name: string;
  label: string;
  defaultValue?: number;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PriceField: React.FC<PriceFieldProps> = ({
  id,
  name,
  label,
  defaultValue,
  required = false,
  disabled = false,
  className,
  labelClassName,
  inputClassName,
  onChange
}) => {
  const baseInputClasses = "w-full p-2 border border-gray-300 dark:border-gray-700 rounded-md dark:bg-gray-800";
  
  return (
    <div className={`mb-4 ${className || ''}`}>
      <label htmlFor={id} className={`block text-sm font-medium mb-1 ${labelClassName || ''}`}>
        {label}{required && <span className="text-red-500 ml-1">*</span>}
      </label>
      
      <div className="relative">
        <input
          type="number"
          id={id}
          name={name}
          className={`${baseInputClasses} pr-8 ${inputClassName || ''}`}
          defaultValue={defaultValue}
          required={required}
          disabled={disabled}
          min="0"
          max="999.99"
          step="1"
          onChange={onChange}
          onInput={(e) => {
            // Limiter à 3 chiffres avant la virgule et 2 après
            const input = e.currentTarget;
            const value = input.value;
            
            // Utiliser une regex pour valider le format (jusqu'à 3 chiffres avant la virgule, jusqu'à 2 après)
            const regex = /^\d{1,3}(\.\d{0,2})?$/;
            
            if (!regex.test(value) && value !== '') {
              // Si le format est invalide, corriger la valeur
              const parts = value.split('.');
              let newValue = parts[0].slice(0, 3); // Max 3 chiffres avant la virgule
              
              if (parts.length > 1) {
                newValue += '.' + parts[1].slice(0, 2); // Max 2 chiffres après la virgule
              }
              
              input.value = newValue;
            }
          }}
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <span className="text-gray-500">€</span>
        </div>
      </div>
    </div>
  );
};

export default PriceField;
